function record(value: unknown): Record<string, unknown> | undefined {
    return value !== null && typeof value === 'object' && !Array.isArray(value)
        ? value as Record<string, unknown> : undefined;
}

export function getChatReasoningDisplay(
    part: { type: string; text?: string; providerMetadata?: unknown },
    modelId?: string,
): 'hidden' | 'progress' | 'reasoning' {
    if (part.type !== 'reasoning' || !part.text?.trim()) return 'hidden';
    const metadata = record(part.providerMetadata);
    if (record(metadata?.coldreach)?.reasoningDisplay === 'progress') return 'progress';
    // Saved replies predate the per-block marker. Opus 5.5 was introduced with
    // display:updates; require an Anthropic signature as well so mixed-provider
    // messages cannot promote a fallback model's private reasoning.
    // https://platform.claude.com/docs/en/build-with-claude/thinking#progress-updates
    if (modelId === 'claude-opus-5-5'
        && typeof record(metadata?.anthropic)?.signature === 'string') return 'progress';
    return 'reasoning';
}
